import { FC } from "react";
import { Box, Button, Typography, useTheme } from "@mui/material";
import Thumbnail from "./Thumbnail";
import { TutorialModel } from "../../../../models/TutorialModel";

type Props = {
  tutorial: TutorialModel;
  onPlay: () => void;
};

/** Card de destaque "Comece por aqui". */
const FeaturedTutorial: FC<Props> = ({ tutorial, onPlay }) => {
  const theme = useTheme();

  return (
    <Box
      onClick={onPlay}
      sx={{
        maxWidth: 900,
        mx: "auto",
        mb: 4,
        borderRadius: "18px",
        overflow: "hidden",
        boxShadow: theme.customShadows.card,
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
        backgroundColor: "background.paper",
        border: `1px solid ${theme.palette.divider}`,
        cursor: "pointer",
        transition: "box-shadow 0.18s, border-color 0.18s",
        "&:hover": { borderColor: theme.palette.brand.creamStroke, boxShadow: theme.customShadows.cardLg },
      }}
    >
      <Box sx={{ flex: { md: "0 0 52%" }, minWidth: 0 }}>
        <Thumbnail videoId={tutorial.url} isNew={tutorial.new_icon} size="hero" />
      </Box>

      <Box sx={{ flex: 1, p: { xs: "22px 20px", md: "32px 36px" }, display: "flex", flexDirection: "column", justifyContent: "center" }}>
        <Typography sx={{ fontSize: 11, fontWeight: 700, letterSpacing: "1.4px", textTransform: "uppercase", color: "primary.main", mb: 1 }}>
          Comece por aqui
        </Typography>
        <Typography sx={{ fontFamily: theme.typography.fontFamilyDisplay, fontSize: 28, lineHeight: 1.2, color: "text.primary", mb: 1.5 }}>
          {tutorial.title}
        </Typography>
        {tutorial.description && (
          <Typography sx={{ fontSize: 14, color: "text.secondary", lineHeight: 1.7, mb: 3 }}>{tutorial.description}</Typography>
        )}
        <Button
          variant="contained"
          onClick={(e) => {
            e.stopPropagation();
            onPlay();
          }}
          sx={{ alignSelf: "flex-start", px: 3, py: 1.25, borderRadius: "10px", fontWeight: 600, fontSize: 14, boxShadow: theme.customShadows.goldButton }}
        >
          Assistir agora
        </Button>
      </Box>
    </Box>
  );
};

export default FeaturedTutorial;
